module.exports = __webpack_public_path__ + "media/images/sindma/footer-skyline-d58d892cd00faeb7128d217b245e30ad.jpg";